var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{attrs:{"is-visible":_vm.isVisible,"is-archivable":false,"is-editable":false,"size":"xl"},on:{"hideModal":function($event){return _vm.hideModal()}},scopedSlots:_vm._u([{key:"header",fn:function(){return undefined},proxy:true},{key:"body",fn:function(){return [_c('Create',{attrs:{"order":_vm.invoice}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }